import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import downloadIcon from '../../../../assets/img/svg/DownloadIcon.svg';
import shareIcon from '../../../../assets/img/svg/ShareIcon.svg';
import danger from '../../../../assets/img/svg/Danger.svg';
import del from '../../../../assets/img/svg/Del.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import { TextField } from '@material-ui/core';
import Pagination from "../../../custom/Pagination";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import upload from '../../../../assets/img/svg/upload.svg';
import deleteIcon from '../../../../assets/img/svg/delete.svg';
import $ from 'jquery';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import Delete from '../../../../assets/img/svg/delete.svg';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import View from '../../../../assets/img/svg/view.svg';
import EasyEdit from 'react-easy-edit';
import active from '../../../../assets/img/svg/active.svg';
import deactive from '../../../../assets/img/svg/deactive.svg';
import { CssTextField } from "../../../custom/textField";

class ListViewPBD extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            ProjectId: 0,
            UserRole: "",
            isView: false,
            render: false,
            DocsName: [],
            DocsListName: [],
            TypeId: 0,
            DocsListothersName: [],
            OthersDocs: [],
            OtherDeleteId: 0,
            tableData: {
                'ProjectId': 0,
                'Typeid': 0,
                'PageNumber': 1,
                'PageSize': 100,
            },
            documentlist: {
                'projectId': 0,
                'typeId': 0,
            },
            postdocs: {
                'ActionBy': '',
                'ActionDate': '',
                'ProjectDocumentId': 0,
                'ProjectId': 0,
                'Comments': '',
                'DocumentDate': '',
                'TypeId': 0,
                'ProjectDocumentTypeId': 0,
            },
            putcomments: {
                "Projectdocumentsid": 0,
                "Comments": "",
                "ActionBy": ""
            },
            putdate: {
                "Projectdocumentsid": 0,
                "ActionBy": "",
                "DocumentDate": ""
            },
            FocusId: 0,
        }
    }

    componentDidMount() {
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.postdocs.ProjectId = localStorage.getItem("DashId");
        this.state.documentlist.projectId = localStorage.getItem("DashId");
        this.state.tableData.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.putcomments.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionDate = moment(new Date()).format('YYYY-MM-DD');
        this.state.putdate.ActionBy = localStorage.getItem("UserRoles");
        this.setState({})
        this.getTypes("DocumentTypes")
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "PreBeachingDocument")
                        this.state.tableData.Typeid = type[0].Id;
                        this.state.documentlist.typeId = type[0].Id;
                        this.state.postdocs.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.documents(this.state.documentlist, this.state.tableData);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AttachFiles = (str, ind) => {
        this.state.postdocs.ProjectDocumentTypeId = str;
        this.setState({})
        this.inputFile.current.click();
    };

    dataTable = (data) => {
        let apiUrl = API.GET_DOCUMENTSNAME + '?ProjectId=' + data.ProjectId + '&Typeid=' + data.Typeid + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.Data.length > 0) {
                        response?.data.Data.map((i) => (
                            this.state?.DocsListName?.map((s) => (
                                i?.Items?.map((a) => (
                                    a.Id == s.ProjectDocumentTypeId ? (a.FileUrl = s.Attachment.FileUrl,
                                        a.DocumentDate = s.DocumentDate,
                                        a.ProjectDocumentId = s.ProjectDocumentId)
                                        : ""
                                ))
                            ))
                        ))
                    }
                    this.setState({ DocsName: response.data, })
                    this.state.render = true;
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    documents = (data, doc) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/List?projectId=' + data.projectId + '&typeId=' + data.typeId;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.setState({
                        DocsListName: response.data,
                    })
                    this.state.DocsListothersName = []
                    this.setState({})
                    if (response?.data.length > 0) {
                        response.data.map((o) => (
                            o.ProjectDocumentTypeId == null ? this.state.DocsListothersName.push(o) : ""
                        ))
                    }
                    this.setState({})
                    this.dataTable(doc)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PREBEACH1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#PBDT .MuiListItemText-primary").removeClass("fw-bolder")
        $("#PBDL").removeClass("active-color")
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PREBEACH1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Prebeaching1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Prebeaching").removeClass("d-none");
        $("#Prebeaching").addClass("d-block");
        $("#PBDT .MuiListItemText-primary").addClass("fw-bolder")
        $("#PBDL").addClass("active-color")
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    UploadFile = (e) => {
        let formData = new FormData()
        Array.from(e.target.files).forEach(async (a) => {
            formData.append("formFiles", a)
        })
        this.Upload_File(this.state.postdocs, formData)
    }

    Upload_File = (data, formData) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/ProcessDocument?ActionBy=' + data.ActionBy + '&ActionDate=' + data.ActionDate + '&ProjectDocumentId=' + data.ProjectDocumentId + '&ProjectId=' + data.ProjectId + '&DocumentDate=' + data.DocumentDate + '&TypeId=' + data.TypeId + '&ProjectDocumentTypeId=' + data.ProjectDocumentTypeId;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.documents(this.state.documentlist, this.state.tableData);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.OtherDeleteId = Id;
        window.$("#deletepopup").modal("show")
    }

    DeleteOthers = () => {
        window.$("#deletepopup").modal("hide")
        this.DeleteOthersApi(this.state.OtherDeleteId, this.state.UserRole)
    }

    DeleteOthersApi = (data, role) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/projectDocumentIds?projectDocumentIds=' + data + '&actionby=' + role;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.documents(this.state.documentlist, this.state.tableData);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    updatecomments = (e, val) => {
        let data = {
            "Projectdocumentsid": val.ProjectDocumentId,
            "Comments": val.Comments.trim(),
            "Status": val.Status,
            "ActionBy": this.state.UserRole,
            "DocumentDate": val.DocumentDate
        }
        this.put_comments(data)
    }

    put_comments = (data) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/UpdateDocumentField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist, this.state.tableData);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    handleChangeDate = (e, str) => {
        let data = {
            "Projectdocumentsid": str.ProjectDocumentId,
            "Comments": str.Comments == null ? "" : str.Comments,
            "Status": null,
            "ActionBy": localStorage.getItem("UserRoles"),
            "DocumentDate": e.target.value
        }
        this.put_comments(data)
    }

    handleInputChange2 = (e, val) => {
        this.state.DocsListothersName.map((i) => (
            i.ProjectDocumentId == val.ProjectDocumentId ? i.Comments = e.target.value : ""
        ))
        this.setState({})
    }

    handleInputChange = (e, str, val) => {
        this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (
            i.Items && i.Items.map((a, index) => (
                a.Id == str.Id ? str.Comments = e.target.value : ""
            ))
        ))
        this.setState({})
    }

    handleInputChange1 = (e, str, val) => {
        let data = {
            "Id": str.Id,
            "Name": str.Name,
            "Status": null,
            "Comments": e.target.value.trim(),
            "Section": val
        }
        this.updatedoccomments(data)
    }

    updatedoccomments = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist, this.state.tableData);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-6 w-50 mt-auto">
                                    <List className="pt-4 mt-4" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"PREBEACH" + "1"} className='textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="PREBEACH" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5 w-50">
                                    <h4> Pre-Beaching / Landing Documents </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -90 }}>
                    {this.state.isView ? <>   {this.state.isMobile ?
                        <table className="dataTable " width="100%">
                            <tbody>
                                <tr className="">
                                    <td className="">
                                        <img src={upload} className="pl-2" style={{ width: "18px", height: "18px", marginTop: '-5px' }} />
                                        <span className="p-2 cursorPointer" onClick={this.upload}>Upload Documents</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr className="">
                                    <td width="100%" height="22px" className="align-middle"><>
                                        <img src={upload} className="pl-2" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }} style={{ width: "18px", height: "18px", marginTop: '-4px' }} />
                                        <span className="p-2 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }}>Upload Documents</span>
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            onChange={(e) => this.UploadFile(e)}
                                            ref={this.inputFile}
                                        />
                                    </>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    </> :
                        <></>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>        '
                        <div className="row px-3">
                            <div className="col-12 pt-2">
                                {this.state.isMobile ? <></> : <h6>Pre-Beaching / Landing Documents</h6>}
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th width="3%" className="border-right"><span className="spandoc-thead">S.No</span></th>
                                            <th className="border-right"><span className="spandoc-thead">Document</span></th>
                                            <th className="border-right spandate-thead"><span className="spandoc-thead Nowrap">Created On</span></th>
                                            <th className="comments-td"><span className="spandoc-thead">Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.render == true ? <>
                                            {this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (<>
                                                {i.Section == '' ? <>
                                                    {i.Items && i.Items.map((a, index) => (<>
                                                        {a.Name && a.Name != "" ?
                                                            <tr className="border-top">
                                                                <td width="3%" className="border-right text-center align-middle"><span className="spandoc-td">{index + 1}</span></td>
                                                                <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                                    <div className="col-12 m-0 p-0 row">
                                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                                            <span className="spandoc-td">{a.Name && a.Name}</span>
                                                                        </div>
                                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                                            {a.FileUrl && a.FileUrl != "" ? <>
                                                                                <button className="completed-button">COMPLETED</button>
                                                                                <a href={a.FileUrl} target="_blank" className="link-colors pl-2">
                                                                                    <img src={View} className="cursorPointer pl-1 viewdel-td" />
                                                                                    <span className="pl-1 cursorPointer link-color">View</span></a>
                                                                                {this.state.isView ? <>
                                                                                    <img src={Delete} className="pl-2 cursorPointer viewdel-td" onClick={() => { this.OpenPopup(a.ProjectDocumentId) }} />
                                                                                    <span className="pl-1 cursorPointer" onClick={() => { this.OpenPopup(a.ProjectDocumentId) }}>Delete</span> </> : <></>}</> : <>
                                                                                {this.state.isView ? <>
                                                                                    <button className="pending-button mr-1">PENDING</button>
                                                                                    <img src={upload} className="cursorPointer ml-4 uploadicon-td" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles(a.Id, index)} />
                                                                                    <span className="pl-1 mr-5 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles(a.Id, index)}>Upload</span>
                                                                                    <input
                                                                                        type="file"
                                                                                        hidden
                                                                                        multiplewidth-td
                                                                                        onChange={(e) => this.UploadFile(e)}
                                                                                        ref={this.inputFile + index}
                                                                                    />
                                                                                </> :
                                                                                    <>
                                                                                        <button className="pending-button mr-4">PENDING</button>
                                                                                        <span className="pl-1 mr-5"></span></>}
                                                                            </>}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="spandate-thead border-right align-middle">
                                                                    {a.FileUrl && a.FileUrl != "" ?
                                                                        this.state.isView == true ? <>
                                                                            {(a.DocumentDate == "" || a.DocumentDate == null) ?
                                                                                <input className="cursorPointer" type="date" placeholder="Click here" onChange={(e) => { this.handleChangeDate(e, a, a.Section) }} id="session-date" name="session-date"></input>
                                                                                : <input type="date" className="cursorPointer" placeholder={a.DocumentDate && moment(a.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")} onChange={(e) => { this.handleChangeDate(e, a, a.Section) }} id="session-date1" name="session-date"></input>
                                                                            }
                                                                        </> :
                                                                            <span className="spandoc-td">{a.DocumentDate && moment(a.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span> : ""}
                                                                </td>
                                                                <td className={`${window.innerWidth < 1080 ? "commentsmobile-td" : "comments-td"} align-middle`}>
                                                                    {this.state.isView == false ?
                                                                        <CssTextField
                                                                            multiline
                                                                            fullWidth
                                                                            disabled
                                                                            variant="outlined"
                                                                            type="text"
                                                                            value={a.Comments && a.Comments}
                                                                            InputProps={{
                                                                                className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                            }}
                                                                        /> :
                                                                        <CssTextField
                                                                            multiline
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            type="text"
                                                                            onChange={(e) => this.handleInputChange(e, a, i.Section)}
                                                                            onBlur={(e) => this.handleInputChange1(e, a, i.Section)}
                                                                            value={a.Comments && a.Comments}
                                                                            InputProps={{
                                                                                className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                            }}
                                                                        />
                                                                    }
                                                                </td>
                                                            </tr> : <></>}
                                                    </>))}</> : ''}
                                            </>))}
                                            {this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (<>
                                                {i.Section && <>
                                                    <tr className="border-top section-color spandoc-thead">
                                                        <td className="border-right border-left" colSpan="6"><span className="spandoc-thead">{i.Section && i.Section}</span></td>
                                                    </tr>
                                                    {i.Section != '' && i.Items && i.Items.map((a, index) => (<>
                                                        <tr className="border-top" onMouseEnter={() => this.setState({ HoverId: a.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                                                            <td className="border-right text-center align-middle"><span className="spandoc-td">{index + 1}</span></td>
                                                            <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                                <div className="col-12 m-0 p-0 row">
                                                                    <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                                        <span className="spandoc-td">{a.Name && a.Name}</span>
                                                                    </div>
                                                                    <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                                        {a.FileUrl && a.FileUrl != "" ? <>
                                                                            <button className="completed-button">COMPLETED</button>
                                                                            <a href={a.FileUrl} target="_blank" className="link-colors pl-2">
                                                                                <img src={View} className="cursorPointer pl-1 viewdel-td" />
                                                                                <span className="pl-1 cursorPointer link-color">View</span></a>
                                                                            {this.state.isView ? <>
                                                                                <img src={Delete} className="pl-2 cursorPointer viewdel-td" onClick={() => { this.OpenPopup(a.ProjectDocumentId) }} />
                                                                                <span className="pl-1 cursorPointer" onClick={() => { this.OpenPopup(a.ProjectDocumentId) }}>Delete</span></> : <></>} </> : <>
                                                                            {this.state.isView ? <><button className="pending-button mr-1">PENDING</button>
                                                                                <img src={upload} className="cursorPointer ml-4 uploadicon-td" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles(a.Id, index)} />
                                                                                <span className="pl-1 mr-5 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles(a.Id, index)}>Upload</span>
                                                                                <input
                                                                                    type="file"
                                                                                    hidden
                                                                                    multiple
                                                                                    onChange={(e) => this.UploadFile(e)}
                                                                                    ref={this.inputFile + index}
                                                                                />
                                                                            </> : <>
                                                                                <button className="pending-button mr-4">PENDING</button>
                                                                                <span className="pl-1 mr-5"></span>
                                                                            </>}
                                                                        </>}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="border-right align-middle">
                                                                {a.FileUrl && a.FileUrl != "" ?
                                                                    this.state.isView == true ? <>
                                                                        {(a.DocumentDate == "" || a.DocumentDate == null) ?
                                                                            <input className="cursorPointer" type="date" placeholder="Click here" onChange={(e) => { this.handleChangeDate(e, a, a.Section) }} id="session-date" name="session-date"></input>
                                                                            : <input type="date" className="cursorPointer" placeholder={a.DocumentDate && moment(a.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")} onChange={(e) => { this.handleChangeDate(e, a, a.Section) }} id="session-date1" name="session-date"></input>
                                                                        }
                                                                    </> :
                                                                        <span className="spandoc-td">{a.DocumentDate && moment(a.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span> : ""}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "comments-td" : ""} align-middle`}>
                                                                {this.state.isView == false ?
                                                                    <CssTextField
                                                                        multiline
                                                                        fullWidth
                                                                        disabled
                                                                        variant="outlined"
                                                                        type="text"
                                                                        value={a.Comments && a.Comments}
                                                                        InputProps={{
                                                                            className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                        }}
                                                                    /> :
                                                                    <CssTextField
                                                                        multiline
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        type="text"
                                                                        onChange={(e) => this.handleInputChange(e, a, i.Section)}
                                                                        onBlur={(e) => this.handleInputChange1(e, a, i.Section)}
                                                                        value={a.Comments && a.Comments}
                                                                        InputProps={{
                                                                            className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                                }
                                                            </td>
                                                        </tr>
                                                    </>))}
                                                </>}
                                            </>))}
                                            {this.state.DocsListothersName && this.state.DocsListothersName.length > 0 ?
                                                <tr className="border-top section-color spandoc-thead">
                                                    <td className="border-right border-left" colSpan="6"><span className="spandoc-thead">Others</span></td>
                                                </tr> : <></>}
                                            {this.state.DocsListothersName && this.state.DocsListothersName.map((i, ind) => (<>
                                                {i.ProjectDocumentTypeId == null ? <>
                                                    <tr className="border-top" onMouseEnter={() => this.setState({ HoverId: i.ProjectDocumentId })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                                                        <td className="border-right text-center align-middle"><span className="spandoc-td">{ind + 1}</span></td>
                                                        <td className="border-right docwidth-td overflow align-middle">
                                                            <div className="col-12 m-0 p-0 row">
                                                                <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                                    <span className="spandoc-td">{i.DocumentName && i.DocumentName}</span>
                                                                </div>
                                                                <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                                    <button className="completed-button">COMPLETED</button>
                                                                    <a href={i?.Attachment?.FileUrl} target="_blank" className="link-colors pl-2">
                                                                        <img src={View} className="cursorPointer pl-1 viewdel-td" />
                                                                        <span className="pl-1 cursorPointer link-color">View</span>
                                                                    </a>
                                                                    {this.state.isView ? <>
                                                                    <img src={Delete} className="pl-2 cursorPointer viewdel-td" onClick={() => { this.OpenPopup(i.ProjectDocumentId) }} />
                                                                    <span className="pl-1 cursorPointer" onClick={() => { this.OpenPopup(i.ProjectDocumentId) }}>Delete</span>
                                                                    </>:<></>}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="border-right align-middle">
                                                            {this.state.isView == true ? <>
                                                                {(i.DocumentDate == "" || i.DocumentDate == null) ?
                                                                    <input className="cursorPointer" type="date" placeholder="Click here" onChange={(e) => { this.handleChangeDate(e, i) }} id="session-date" name="session-date"></input>
                                                                    : <input type="date" className="cursorPointer" placeholder={i.DocumentDate && moment(i.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")} onChange={(e) => { this.handleChangeDate(e, i) }} id="session-date1" name="session-date"></input>
                                                                }
                                                            </> :
                                                                <span className="spandoc-td">{i.DocumentDate && moment(i.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span>}
                                                        </td>
                                                        <td className="align-middle spandoc-td">
                                                            {this.state.isView == false ?
                                                                <CssTextField
                                                                    multiline
                                                                    fullWidth
                                                                    disabled
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={i.Comments && i.Comments}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-td ${classes.inputfieldAlign}`
                                                                    }}
                                                                /> :
                                                                <CssTextField
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onChange={(e) => this.handleInputChange2(e, i)}
                                                                    onBlur={(e) => this.updatecomments(e, i)}
                                                                    value={i.Comments && i.Comments}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-td ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            }

                                                        </td>
                                                    </tr></> : ""}
                                            </>))} </> : <></>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteOthers()}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewPBD)));
